import { getDay, startOfWeek as dfStartOfWeek, parse, format } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import { dateFnsLocalizer } from 'react-big-calendar';
import { DEFAULT_WEEK_DAY } from './constants';

export const locales = {
	'en-US': enUS,
};

export const createLocalizer = (weekStartsOn = DEFAULT_WEEK_DAY) => {
	const startOfWeek = (date, options) => {
		return dfStartOfWeek(date, { ...options, weekStartsOn });
	};

	return dateFnsLocalizer({
		format,
		parse,
		startOfWeek,
		getDay,
		locales,
	});
};
